import React, { Component, useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
// import logo from '../logo.svg';
import Tap from "react-interactions";
import "react-interactions/dist/main.css";
import styled, { css } from "styled-components";

import { eraseCookie } from "./Cookie";

import { ProductConsumer } from "../../context";

import { Button } from "@material-ui/core";
import XLogin from "./XLogin.js";

import { ProductContext } from "../../context";

import { CssList0 } from "./ProductList";

import { CssMenu, CssMenuBorder } from "../account/UserAccount";
import { CssMenuLi, CssMenuLi0 } from "../account/Tabs";
import { CssTab } from "./MenuMaterial";



export function Navbar({
  history,
  match,
  location,
  root = '/'
}) {
  let valueFromContext = useContext(ProductContext);

  const [state, setState] = React.useState({
    shown: false
  });

  const [shown, setShown] = React.useState(false);

  const logOutHandler = () => {
    eraseCookie("xsolla_login_token", null);
    eraseCookie("xsolla_last_click_id", null);
    window.location.reload();
  };

  const logInButtonHandler = () => {
    setState({ shown: true });
  };

  const showCart = () => {
    valueFromContext.setStateFrom("cartShown", true);
  };
  const showAccount = () => {
    valueFromContext.setStateFrom("accountShown", true);
  };

  let [cart, setCart] = useState({});
  let [cartNum, setCartNum] = useState(0);

  let [fav, setFav] = useState({});
  let [favNum, setFavNum] = useState(0);




  useEffect(() => {
    calculateCart();
    calculateFav();
  }, [valueFromContext]);

  const calculateCart = () => {
    let in_cartNew = 0;
    let newCart = {};
    newCart = Object.assign(newCart, cart);

    if (valueFromContext && valueFromContext["virtualItems"])
      valueFromContext["virtualItems"].forEach((oneGroup, indG) => {
        oneGroup["products"].forEach((oneProduct, indP) => {
          if (oneProduct.in_cart) {
            newCart[oneProduct.id] = oneProduct.in_cart;
          } else {
            delete newCart[oneProduct.id];
          }
        });
      });

    Object.keys(newCart).forEach((oneCart, ind) => {
      let oneCartNum = newCart[oneCart];
      in_cartNew = in_cartNew + parseInt(oneCartNum);
    });
    if (in_cartNew !== cartNum) {
      setCartNum(in_cartNew);
    }
    setCart(newCart);
  };

  const calculateFav = () => {
    let in_favNew = 0;
    let newFav = {};
    newFav = Object.assign(newFav, fav);

    if (valueFromContext && valueFromContext["virtualItems"])
      valueFromContext["virtualItems"].forEach((oneGroup, indG) => {
        oneGroup["products"].forEach((oneProduct, indP) => {
          if (oneProduct.is_favorite) {
            newFav[oneProduct.id] = oneProduct.is_favorite;
          } else {
            delete newFav[oneProduct.id];
          }
        });
      });

    Object.keys(newFav).forEach((oneCart, ind) => {
      let oneCartNum = newFav[oneCart];
      in_favNew = in_favNew + parseInt(oneCartNum);
    });
    if (in_favNew !== favNum) {
      setFavNum(in_favNew);
    }
    setFav(newFav);
  };

// debugger

  return (
    <CssNavWrapper0>
    {history && <CssNavWrapper
        sb={valueFromContext["sbShown"]}
        style={{
          color: valueFromContext.getTheme("colorText"),
          backgroundColor: valueFromContext.getTheme("colorBg")
        }}
        theme={valueFromContext.getTheme()}
      >
        {/* <CssList0> */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            height: "100%"
          }}
        >
          <div
            style={{
              flexGrow: 1,
              alignSelf: 1,
              height: "100%",
              alignItems: "stretch",
              display: "flex"
              // display: 'grid',
              // gridTemplateColumns: '24% 70%',
              // gridColumnGap: '4%',
              // gridRowGap: 16,
            }}
          >
            {/* <CssMenuBorder theme={valueFromContext.getTheme()}/> */}

            <CssTab

            // theme={valueFromContext.getTheme()}
            // onClick={()=>{
            //   handleUrl('profile')
            // }}
            >
              <CssName to={`${root}`} className="link">
                <CssMenuLi
                  theme={valueFromContext.getTheme()}
                  active={
                    match && !match.params.id
                      ? true
                      : false
                  }
                >
                  Store
                </CssMenuLi>
              </CssName>
              <Tap scale waves hover />
            </CssTab>

            <CssTab>
              <CssName to={`${root}inventory`} className="link">
                <CssMenuLi
                  theme={valueFromContext.getTheme()}
                  active={
                    history &&
                    match.params.id &&
                    match.params.id === `inventory`
                      ? true
                      : false
                  }
                >
                  Inventory {!!favNum && favNum}
                </CssMenuLi>
              </CssName>
            </CssTab>
          </div>

          <NavUl>
            {!!cartNum && (
              <CssCartIcon0 to={`${root}cart`}>
                <CssButtonCart
                  onClick={e => showCart()}
                  theme={valueFromContext.getTheme()}
                >
                  <span
                    className="mr-10"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <i
                      className="fas fa-cart-plus"
                      style={{ fontSize: "1em" }}
                    ></i>
                    <CssHideOnTablet>Cart</CssHideOnTablet>
                  </span>
                  <CssButtonCartNum theme={valueFromContext.getTheme()}>
                    {cartNum}
                  </CssButtonCartNum>
                </CssButtonCart>
              </CssCartIcon0>
            )}

            <CssLoginPanel
              shown={shown}
              onMouseEnter={() => {
                setShown(true);
              }}
            >
              <CssLoginPop0
                shown={shown}
                onMouseLeave={() => {
                  setShown(false);
                }}
              >
                <CssLoginPopLiEmpty to={`${root}profile`}> </CssLoginPopLiEmpty>
                <CssLoginPopB theme={valueFromContext.getTheme()}>
                  <CssLoginPopLi to="/store/profile">
                    {/* <i class="fas fa-user-circle"></i>  */}
                    Profile
                  </CssLoginPopLi>
                  <CssLoginPopLi to={`${root}orders`}>
                    {/* <i class="fas fa-box-check"></i>  */}
                    Orders
                  </CssLoginPopLi>
                  <CssLoginPopLi to={`${root}subscriptions`}>
                    {/* <i class="fas fa-alarm-clock"></i>  */}
                    Subscriptions
                  </CssLoginPopLi>
                  <CssLoginPopLi to={`${root}payment`}>
                    {/* <i class="fas fa-credit-card-blank"></i>  */}
                    Payment&nbsp;methods
                  </CssLoginPopLi>
                  <CssLoginPopLi to={`${root}notifications`}>
                    {/* <i class="fas fa-engine-warning"></i>  */}
                    Notifications
                  </CssLoginPopLi>
                  <div style={{ padding: 16 }}>
                    <CssButton
                      onClick={logOutHandler}
                      theme={valueFromContext.getTheme()}
                    >
                      <span className="mr-10">
                        <i className="fas fa-sign-out-alt"></i> Log out
                      </span>
                    </CssButton>
                  </div>
                </CssLoginPopB>
              </CssLoginPop0>

              {!valueFromContext.logToken && (
                <CssButton onClick={logInButtonHandler}>Log In</CssButton>
              )}

              {valueFromContext.logToken && valueFromContext.user && (
                <CssLogin shown={shown}>
                  <CssLoginEmail
                    to="/profile"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 100,
                        backgroundImage:
                          "url(" + valueFromContext.user["picture"] + ")",
                        backgroundSize: "cover"
                      }}
                    ></div>
                    <CssEmail>
                      &nbsp;&nbsp;
                      {valueFromContext.user.email
                        ? valueFromContext.user.email.split("@")[0]
                        : "Profile"}{" "}
                      <span className="mr-10">
                        <i className="fas fa-bars"></i>
                      </span>
                    </CssEmail>
                  </CssLoginEmail>
                </CssLogin>
              )}
            </CssLoginPanel>
            <XLogin />
          </NavUl>
        </div>
        {/* </CssList0> */}
      </CssNavWrapper>
    }

    </CssNavWrapper0>
  );
}



export default withRouter(Navbar);



const CssEmail = styled.div`
  display: block;

  @media (max-width: 767px) {
    display: none;
  }
`;

const CssNavWrapper0 = styled.div`
  height: 58px;
  position: relative;
`;

const CssNavWrapper = styled.div`

  height: 100%;
  /* color: var(--mainWhite); */
  /* background-color: var(--mainBlue); */

  position: fixed;


  top: ${({ sb }) => (sb ? "64px" : "0px")};

  left: ${({ sb }) => (sb ? "320px" : "0px")};
  right: 0;

  display:flex;
  flex-wrap: wrap;
  max-height: 56px;
  /* flex-grow:1; */
  /* flex-direction: row; */
  align-items:center;
  z-index:10;
  /* padding: 0 ${({ theme }) =>
    theme ? parseInt(theme["cardWidth"], 0) / 6 : 40}px; */
  padding: 0 2em;
  & a {
    color: ${({ theme }) => theme["colorAccent"]};
    text-decoration: none;
  };

  @media (max-width: 767px) {
    top: 0 !important;
    left: 0 !important;
  }

  @media (max-width: 479px) {
    left: 0 !important;
  }

`;

const NavUl = styled.div`
  display: flex;
  flex-grow: 0;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  list-style-type: none;
  /* background-color: var(--mainBlue); */
  position: relative;
  z-index: 10;
  margin-bottom: 0;
  flex-wrap: wrap;
`;

const CssButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 0.8rem;
  line-height: 2em;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  font-family: "Roboto";
  color: ${({ theme }) => theme.colorAccent};
  border: 1px solid ${({ theme }) => theme.colorAccent};
  border-radius: 4px;
  padding: 0 0.6rem;
  cursor: pointer;
  /* border: 1px solid red; */
`;

export const CssButtonCartNum = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0em 0.4em;
  font-weight: bolder;
  position:relative;
  /* font-size: 0.8em; */
  color: ${({ theme }) => theme.colorAccentText};
  /* background: ${({ theme }) => theme.colorBg}; */
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  text-decoration: none;
  &:hover {
    // background: var(--lightBlue);
    text-decoration: none;
  }
`;

export const CssButtonCart = styled.div`
  display: flex;
  padding: 0.2em 0.8em;
  font-weight: bolder;
  position: relative;
  text-transform: uppercase;
  margin-right: 1em;
  border-radius: 4px;
  font-size: 0.8em;
  color: ${({ theme }) => theme.colorAccentText};
  background: ${({ theme }) => theme.colorAccent};
  cursor: pointer;
  transition: all 0.5s ease-in-out;
  text-decoration: none;
  &:hover {
    // background: var(--lightBlue);
    text-decoration: none;
  }
`;

const CssLoginPanel = styled.div`
  height: 100%;
  padding: 4px;
  flex-grow: 0;
  text-transform: uppercase;
  overflow: hidden;
  position: relative;
  ${({ shown }) =>
    shown &&
    css`
       {
        position: static;
        overflow: auto;
      }
    `};
`;

const CssLoginEmail = styled(Link)`
  margin: 0 1rem 0 0.4em;
  cursor: pointer;
  transition: opacity 0.2ms ease-in;
  &:hover {
    opacity: 0.8;
  }
`;

const CssLogin = styled.div`
  /* text-align:center; */
  display: flex;
  flex-direction: row;
  align-items: center;
  /* padding: 0 1em; */
  z-index: 0;
  ${({ shown }) =>
    shown &&
    css`
       {
        z-index: 2;
      }
    `};
`;

const CssName = styled(Link)`
  height: 100%;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme && theme["colorBg"]};
  color: ${({ theme }) => theme && theme["colorText"]};

  position: relative;
  z-index: 10;
  display: flex;
  justify-content: center;
  flex-flow: column nowrap;
  text-transform: uppercase;
  flex-grow: 1;
  font-size: 1.4rem;
  line-height: 1.4rem;
  cursor: pointer;
  &:hover {
    opacity: 1;
  }
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    font-size: 1.2em;
    line-height: 1.2rem;
  }

  @media (max-width: 479px) {
  }
`;

const CssHideOnMobile = styled.span`
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
  }

  @media (max-width: 479px) {
    display: none;
  }
`;

const CssHideOnTablet = styled.span`
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
    display: none;
  }

  @media (max-width: 479px) {
  }
`;

const CssCartIcon0 = styled(Link)`
  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
  }

  @media (max-width: 479px) {
    position: fixed;
    bottom: 16px;
    right: 16px;
    height: 44px;
    display: flex;
    align-items: stretch;
    font-size: 1.4em;
  }
`;

export const CssLoginPop0 = styled.div`
  position: absolute;
  right: -30px;
  top: 0px;
  left: 0px;
  border-radius: 3;
  box-shadow: 0px 2px 8px -2px black;
  transition: all 200ms ease-in-out;
  transform: translateY(-16px);
  padding: 0;
  opacity: 0;
  ${({ shown }) =>
    shown &&
    css`
       {
        transform: translateY(0px);
        opacity: 1;
        z-index: 1;
      }
    `};

  @media (max-width: 991px) {
  }

  @media (max-width: 767px) {
  }

  @media (max-width: 479px) {
  }
`;

export const CssLoginPopB = styled.div`
  background: ${({ theme }) => (theme ? theme.colorBg : "white")} & a {
    transition: all 250ms ease-in-out;
  }
  & a:hover {
    background: ${({ theme }) => theme.colorAccent};
    color: ${({ theme }) => theme.colorAccentText};
  }
`;
const CssLoginPopLi = styled(Link)`
  position: relative;
  display: block;
  padding: 0.4em 16px;
`;
const CssLoginPopLiEmpty = styled(Link)`
  height: 48px;
  display: block;
  width: 100%;
`;
